// @ts-strict-ignore
import React from 'react'
import { convertRateMode } from 'services/rate'
import { FormValue, RateMode } from 'types'
import RateField from './RateField'

export interface IRateFieldWrapperProps {
  minRate?: number
  maxRate?: number
  onMinRateChange?: (value: number) => void
  onMaxRateChange?: (value: number) => void
  minAnnualCompensation?: number
  maxAnnualCompensation?: number
  onMinAnnualCompensationChange?: (value: number) => void
  onMaxAnnualCompensationChange?: (value: number) => void
  rateMode?: RateMode
  onRateModeChange: (value: RateMode) => void
  label?: string
  errorText?: string
  currency?: FormValue<string>
  onMinRateBlur?: () => void
  onMaxRateBlur?: () => void
}

export interface IRateFieldWrapperState {
}

// TODO: get rid of this wrapper, simplify code, get rid of annual compensation on the job form

export default class RateFieldWrapper extends React.PureComponent<IRateFieldWrapperProps, IRateFieldWrapperState> {
  render() {
    const {
      minRate,
      maxRate,
      minAnnualCompensation,
      maxAnnualCompensation,
      rateMode,
      onRateModeChange,
      label,
      errorText,
      currency,
      onMinRateBlur,
      onMaxRateBlur,
    } = this.props

    const minRateValue = minRate ?? (convertRateMode(minAnnualCompensation, 'year', rateMode))
    const maxRateValue = maxRate ?? (convertRateMode(maxAnnualCompensation, 'year', rateMode))

    return (
      <RateField
        onMinRateBlur={onMinRateBlur}
        onMaxRateBlur={onMaxRateBlur}
        minRate={minRateValue}
        maxRate={maxRateValue}
        onMinRateChange={this.handleMinRateChange}
        onMaxRateChange={this.handleMaxRateChange}
        rateMode={rateMode}
        onRateModeChange={onRateModeChange}
        label={label}
        errorText={errorText}
        currency={currency}
      />
    )
  }

  handleMinRateChange = (value: number) => {
    const { onMinRateChange, onMinAnnualCompensationChange, rateMode } = this.props

    if (onMinRateChange) {
      onMinRateChange(value)
    }

    if (onMinAnnualCompensationChange) {
      onMinAnnualCompensationChange(convertRateMode(value, rateMode, 'year'))
    }
  }

  handleMaxRateChange = (value: number) => {
    const { onMaxRateChange, onMaxAnnualCompensationChange, rateMode } = this.props

    if (onMaxRateChange) {
      onMaxRateChange(value)
    }

    if (onMaxAnnualCompensationChange) {
      onMaxAnnualCompensationChange(convertRateMode(value, rateMode, 'year'))
    }
  }
}
